// Brand mark: official LC Shield emblem (blue shield + interlocking "LC" monogram).
// Renders the transparent-background PNG asset centered in a flex box so it sits
// perfectly level with adjacent wordmark text. `size` sets rendered height (px).
import logo from "@/assets/lc-shield-logo.webp";

export const LCShieldLogo = ({ size = 26, className = "" }) => (
  <span
    className={className}
    style={{
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: size,
      width: Math.round(size * 84 / 96),
      flexShrink: 0,
      lineHeight: 0,
    }}
  >
    <img
      src={logo}
      alt="LC Shield"
      width={Math.round(size * 84 / 96)}
      height={size}
      style={{ height: size, width: Math.round(size * 84 / 96), display: "block", flexShrink: 0 }}
      draggable={false}
    />
  </span>
);

export default LCShieldLogo;
